class SearchCourseBlock
{
	constructor(el: Element)
	{
		const input = el.querySelector<HTMLInputElement>("#course-search-input");
		const select = el.querySelector<HTMLSelectElement>("#study-level-select");
		const findBtn = el.querySelector<HTMLAnchorElement>("#find-course-btn");

		// Read URLs from data attributes
		const undergraduateUrl = el.getAttribute("data-undergraduate-url")!;
		const postgraduateUrl = el.getAttribute("data-postgraduate-url")!;

		if (input && select && findBtn)
		{

			// Function to update the button href
			const updateHref = () =>
			{
				const query = input.value.trim();
				const level = select.value;

				if (!level)
				{
					findBtn.href = "#"; // Default if no option selected
					return;
				}

				if (level === "Undergraduate")
				{
					findBtn.href = undergraduateUrl + "?q=" + encodeURIComponent(query);
				} else if (level === "Postgraduate")
				{
					findBtn.href = postgraduateUrl + "?q=" + encodeURIComponent(query);
				}
			};

			// Update href whenever the input or select changes
			select.addEventListener("change", updateHref);
			input.addEventListener("input", updateHref);

			// Validation on click
			findBtn.addEventListener("click", (e) =>
			{
				const query = input.value.trim();
				const level = select.value;

				if (!query)
				{
					e.preventDefault();
					alert("Please enter a course or keyword.");
					return;
				}
				if (!level)
				{
					e.preventDefault();
					alert("Please select a study level.");
					return;
				}

				// href is already updated via updateHref
			});
		}
	}
}

document.querySelectorAll(".search-course").forEach(el =>
{
	new SearchCourseBlock(el);
});
